import { FacebookTargetingSpec } from '../facebook/audience/Targeting';
import { DemographicAttributionInsights } from './DemographicAttributionInsights';
import { HourlyAttributionInsights } from './HourlyAttributionInsights';
import { PlacementAttributionInsights } from './PlacementAttributionInsights';

export type CustomerType = 'New' | 'Repeat';

export type BreakdownType = 'Demographic' | 'Hourly' | 'Placement';

export enum InsightsTableLevel {
  campaign = 'campaign',
  adset = 'adset',
  ad = 'ad',
}

export type AttributionBreakdownRows =
  | DemographicAttributionRows
  | HourlyAttributionRows
  | PlacementAttributionRows;

export interface DailyInsightAggregate {
  date: string; // YYYY-MM-DD
  conversions: number;
  new_conversions: number;
  repeating_conversions: number;
  revenue?: number;
  new_revenue?: number;
  repeating_revenue?: number;
}

export interface InsightsEgressResponse {
  aggregates: DailyInsightAggregate[];
}

export const exampleInsightsEgressResponse: InsightsEgressResponse = {
  aggregates: [],
};

export interface AttributionInsights {
  day: string; // '2020-01-01'
  type: CustomerType; // 'New' | 'Repeat'
  revenue?: number;
  revenueAverage?: number;
  campaignName: string;
  adSetName: string;
  adName: string;
  adPreview: string; // iframe
  pageID: string; // for ad preview link
  storyID: string; // for ad preview link
}

interface AttributionRows<T extends AttributionInsights> {
  breakdownType: BreakdownType;
  rows: T[];
}

export interface DemographicAttributionRows
  extends AttributionRows<DemographicAttributionInsights> {
  breakdownType: 'Demographic';
}

export interface HourlyAttributionRows
  extends AttributionRows<HourlyAttributionInsights> {
  breakdownType: 'Hourly';
}

export interface PlacementAttributionRows
  extends AttributionRows<PlacementAttributionInsights> {
  breakdownType: 'Placement';
}

export const exampleAttributionInsight: AttributionInsights = {
  day: '2020-01-01',
  type: 'New',
  revenue: 20.0,
  campaignName: "4. Oct-Jan '19: (Lead Gen)",
  adSetName: 'Lookalike',
  adName: '4a. Dynamic Creative',
  adPreview:
    '<iframe src="https://www.facebook.com/ads/api/preview_iframe.php" width="335" height="450" scrolling="yes" style="border: none;"></iframe>',
  pageID: '111111111111',
  storyID: '222222222222',
};

export interface TableDailyInsightAggregates extends DailyInsightAggregate {
  key: string;
}

export interface InsightsTableRow {
  level: InsightsTableLevel;
  campaign_name: string; // always
  campaign_id: string; // always
  campaign_start?: string; // if campaign level
  campaign_end?: string; // if campaign level
  adset_id?: string; // if adset / ad level
  adset_name?: string; // if adset / ad level
  adset_targeting?: FacebookTargetingSpec;
  ad_name?: string; // if ad level
  ad_id?: string; // if  ad level
  ad_preview?: string; // if ad level
  page_id?: string; // If ad level
  story_id?: string; // If ad level
  spend: number;
  impressions: number;
  aggregates: TableDailyInsightAggregates[];
}
